module.exports = __webpack_public_path__ + "static/media/Stellar Single Bed Base - 120x200 cm_Cream.38cfe7ca.png";